import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getCourses } from "../../../../services/dashboard/apiCourses";

export function useCourses({
  filter,
  searchValue,
  include,
  includeFields,
  sortBy,
  perPage,
  page = 1,
  filterAndSortAndPageQuery,
} = {}) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: courses,
    isSuccess,
  } = useQuery({
    queryKey: [
      "coursesDashboard",
      page,
      perPage,
      filter,
      searchValue,
      include,
      includeFields,
      sortBy,
      filterAndSortAndPageQuery,
    ],
    queryFn: () =>
      getCourses({
        filter,
        include,
        searchValue,
        includeFields,
        sortBy,
        page,
        perPage,
        filterAndSortAndPageQuery,
      }),
  });

  const totalPages = Math.ceil(courses?.meta?.total / courses?.meta?.per_page);

  // PRE-FETCHING
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: [
        "coursesDashboard",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getCourses({
          filter,
          include,
          searchValue,
          includeFields,
          sortBy,
          page: page++,
          perPage,
          filterAndSortAndPageQuery,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: [
        "coursesDashboard",
        page,
        perPage,
        filter,
        searchValue,
        include,
        includeFields,
        sortBy,
        filterAndSortAndPageQuery,
      ],
      queryFn: () =>
        getCourses({
          filter,
          include,
          searchValue,
          includeFields,
          sortBy,
          page: page--,
          perPage,
          filterAndSortAndPageQuery,
        }),
    });
  }

  return { isPending, courses };
}
